<!-- product-list.component.html -->
<!-- <app-header></app-header>
<app-footer></app-footer> -->
<router-outlet></router-outlet>
